/* ==========================================
   GREAT REMINDERS – LEADERSHIP JOURNEY ENGINE
   Master what matters with clarity, focus, and impact
========================================== */

(function(){

const TOOLBOX_KEY = "gr_toolbox_v1";
const REQUIRED_APPLIES = 3;


/* =====================================
URL NORMALIZATION (same logic as playbook)
===================================== */

function normalizePath(input){

try{

let p = /^https?:\/\//i.test(input)
? new URL(input, location.origin).pathname
: (input || '');

p = p.replace(/[?#].*$/,'');
p = p.replace(/\/index\.html?$/i,'');
p = p.replace(/\/+/g,'/');

if(p.length>1) p = p.replace(/\/$/,'');

if(!p.startsWith('/')) p='/'+p;

return p || '/';

}catch{
return input || '/';
}

}


function getHandleFromUrl(url){

const path = normalizePath(url);

return path.split('/').filter(Boolean).pop();

}


/* =====================================
JOURNEY CONFIG
===================================== */

const JOURNEY = [

{title:"WIN Your Mindset",skill:"Mental clarity and decision control",url:"/pages/master-your-mindset"},
{title:"MVP-WW-123 Productivity",skill:"Focus on what moves the needle",url:"/pages/master-your-productivity"},
{title:"PAUSE to Listen",skill:"Master active listening",url:"/pages/master-active-listening"},
{title:"Communicate TV-CIK-GPS",skill:"Communicate clearly and strategically",url:"/pages/masterclass-how-to-communicate-effectively-at-work"},
{title:"Coach with GROW",skill:"Develop people through coaching",url:"/pages/master-coaching"},
{title:"I-BUILD Feedback",skill:"Deliver powerful feedback",url:"/pages/feedback"},
{title:"TRUST Team Performance",skill:"Build high-performing teams",url:"/pages/building-high-performance-teams"}

];


/* =====================================
PLAYBOOK HELPERS
===================================== */

function getPlaybook(){

try{
return JSON.parse(localStorage.getItem(TOOLBOX_KEY)) || [];
}catch{
return [];
}

}

function savePlaybook(data){

localStorage.setItem(TOOLBOX_KEY,JSON.stringify(data));

document.dispatchEvent(new Event("gr:changed"));

}


/* =====================================
SAVE FRAMEWORK TO PLAYBOOK
===================================== */

function saveFramework(url){

let playbook = getPlaybook();

const handle = getHandleFromUrl(url);

if(playbook.find(i=>i.handle===handle)) return;

playbook.push({

handle:handle,
title:handle,
url:normalizePath(url),
appliedCount:0,
status:"not_started"

});

savePlaybook(playbook);

}


/* =====================================
FRAMEWORK PROGRESS
===================================== */

function getFrameworkProgress(url){

const items = getPlaybook();

const handle = getHandleFromUrl(url);

const item = items.find(i=>i.handle===handle);

if(!item){
return {saved:false,applies:0};
}

return{

saved:true,
applies:item.appliedCount || 0

};

}


/* =====================================
CALCULATE JOURNEY PROGRESS
===================================== */

function calculateProgress(){

let completed = 0;

JOURNEY.forEach(step=>{

const progress = getFrameworkProgress(step.url);

if(progress.applies >= REQUIRED_APPLIES){
completed++;
}

});

return completed;

}


/* =====================================
GET CURRENT STEP
===================================== */

function getCurrentStep(){

let current = 0;

JOURNEY.forEach((step,index)=>{

const progress = getFrameworkProgress(step.url);

if(progress.applies >= REQUIRED_APPLIES){
current = index + 1;
}

});

return current;

}


/* =====================================
RENDER PROGRESS BAR
===================================== */

function renderProgress(){

const root = document.getElementById("gr-journey-progress");
if(!root) return;

const done = calculateProgress();
const total = JOURNEY.length;

const percent = Math.round((done/total)*100);

root.innerHTML = `

<div class="gr-journey-progress">

<div class="gr-journey-progress-title">
Leadership Journey Progress
</div>

<div class="gr-journey-progress-sub">
Progress through the journey by applying each framework ${REQUIRED_APPLIES} times in real situations.
</div>

<div class="gr-journey-bar">
<div class="gr-journey-fill" style="width:${percent}%"></div>
</div>

<div class="gr-journey-progress-count">
${done} / ${total} steps completed
</div>

</div>

`;

}


/* =====================================
RENDER JOURNEY ROADMAP
===================================== */

function renderJourney(){

const container = document.querySelector(".leader-journey");

if(!container) return;

const stepIndex = getCurrentStep();

container.innerHTML="";

JOURNEY.forEach((step,i)=>{

const progress = getFrameworkProgress(step.url);

let state="locked";
let icon="🔒";

/* state logic */

if(i < stepIndex){

state="completed";
icon="✓";

}

else if(i === stepIndex){

if(progress.saved){

state="applying";
icon="⚙";

}else{

state="active";
icon="→";

}

}

let progressLine="";
let actionButton="";

if(progress.saved){

progressLine=`
<div class="journey-progress-small">
Applied ${progress.applies} / ${REQUIRED_APPLIES} times
</div>`;

}

else if(state==="active"){

actionButton=`
<button class="journey-save-btn" data-url="${step.url}">
Save to Playbook
</button>`;

}

const el=document.createElement("div");

el.className="journey-step journey-"+state;

el.innerHTML=`

<div class="journey-card">

<div class="journey-number">${icon}</div>

<div class="journey-main">

<div class="journey-title">${step.title}</div>

<div class="journey-skill">${step.skill}</div>

${progressLine}

${actionButton}

</div>

<a href="${step.url}" class="journey-open">
Open
</a>

</div>

`;

container.appendChild(el);

});


/* attach save buttons */

document.querySelectorAll(".journey-save-btn").forEach(btn=>{

btn.addEventListener("click",function(){

saveFramework(this.dataset.url);

updateAll();

});

});

}


/* =====================================
NEXT STEP PANEL
===================================== */

function renderNextStep(){

const container=document.getElementById("journey-next-step");

if(!container) return;

const stepIndex=getCurrentStep();

const step=JOURNEY[stepIndex];

if(!step){

container.innerHTML=`

<div class="journey-complete">

Leadership Journey Completed

You have applied every leadership framework in real situations.

Download your Leadership Certificate and join the Great Reminders Hall of Leaders.

</div>

`;

return;

}

const progress=getFrameworkProgress(step.url);

container.innerHTML=`

<div class="journey-next">

<div class="journey-next-title">
Your Next Leadership Step
</div>

<a href="${step.url}" class="next-framework">
${step.title}
</a>

<div class="next-steps">

<div class="next-step">1. Read the framework</div>
<div class="next-step">2. Save it to your Playbook</div>
<div class="next-step">3. Apply it ${REQUIRED_APPLIES} times in real situations</div>

</div>

<div class="next-progress">
Applications completed: ${progress.applies} / ${REQUIRED_APPLIES}
</div>

</div>

`;

}


/* =====================================
AUTO UPDATE
===================================== */

function listenForUpdates(){

window.addEventListener("storage",updateAll);

document.addEventListener("gr:changed",updateAll);

}

function updateAll(){

renderProgress();

renderJourney();

renderNextStep();

}


/* =====================================
BOOT
===================================== */

function boot(){

renderProgress();

renderJourney();

renderNextStep();

listenForUpdates();

}

document.addEventListener("DOMContentLoaded",boot);

})();